import 'jquery.maskedinput/dist/jquery.maskedinput.js';
import $datepicker from '../components/datepicker.js';
/**
 * Formcontrol
 */
function $formcontrollify (element, pickerOptions) {

    element = element || '[data-js-formcontrol]';
    var $el = $(element);

    const opt = {};

    return $el.each(function () {

        var $this = $(this);
        initSelects($this);
        initDatePicker($this);
        initTimeMask($this);
        initOpenEnd($this);
        initType($this);

    });

    function initSelects ($el) {
        var $catSelects = $el.find('[data-js-formcontrol-category-select]'),
            $subcatSelects = $el.find('[data-js-formcontrol-subcategory-select]');

        $catSelects.bind('change.formcontrol-category', function () {
            var cat = $(this).children('option:selected').attr('data-js-formcontrol-category-id');
            $subcatSelects.children('option').attr('disabled', true).removeAttr('selected').hide();
            $subcatSelects.children('option:first-child').attr('selected', true).show();
            $subcatSelects.children('[data-js-formcontrol-childof-category="'+cat+'"]').removeAttr('disabled').show();
            $subcatSelects.removeAttr('disabled');
        });
    }

    function initType ($el) {
        var $typeCheckbox = $el.find('[data-js-formcontrol-type-checkbox]'),
            $typeContainers = $el.find('[data-js-formcontrol-type-container]');

        $typeCheckbox.bind('change.formcontrol-type', function () {
            var $this = $(this),
                isChecked = $this.is(':checked'),
                type = (isChecked) ? 'recurrent' : 'single'; /** TODO: Refactor this into options */
            $typeContainers.each(function () {
                var attr = $(this).attr('data-js-formcontrol-type-container') || 'single'
                $(this).toggleClass('is-active', attr === type);
            });
        });
    }

    function initDatePicker ($el) {
        var $datepickerElement = $datepicker($el.find('[data-js-formcontrol-datepicker]')),
            datepicker = $datepickerElement.pickadate('picker');

        /** If the there is no prefilled date then set it to today */
        if (!datepicker.get('select')) datepicker.set('select', 'today');
    }

    function initTimeMask ($el) {
        var $timepickerElement = $el.find('[data-js-formcontrol-timepicker]');
        $timepickerElement.mask('99:99', {
            placeholder: 'hh:mm'
        });
        $timepickerElement.first().val('13:00'); // TODO: Get current time
    }

    function initOpenEnd ($el) {
        var $checkbox = $el.find('[data-js-formcontrol-openend-checkbox]'),
            $inputs = $el.find('[data-js-formcontrol-openend-disable]');

        $checkbox.bind('change.formcontrol-openend', function () {
            var state = $(this).is(':checked');
            $inputs.toggleClass('is-hidden', state);
        });
    }

}

export default $formcontrollify;



// WEBPACK FOOTER //
// ./src/js/app/components/formcontrol.js